import { useTranslation } from 'react-i18next';

export default function WindowsProcess() {
  const { t } = useTranslation();

  const steps = [
    { numKey: 'wnp1_num', icon: 'ri-phone-line', titleKey: 'wnp1_title', textKey: 'wnp1_text' },
    { numKey: 'wnp2_num', icon: 'ri-ruler-line', titleKey: 'wnp2_title', textKey: 'wnp2_text' },
    { numKey: 'wnp3_num', icon: 'ri-file-list-3-line', titleKey: 'wnp3_title', textKey: 'wnp3_text' },
    { numKey: 'wnp4_num', icon: 'ri-tools-line', titleKey: 'wnp4_title', textKey: 'wnp4_text' },
    { numKey: 'wnp5_num', icon: 'ri-check-double-line', titleKey: 'wnp5_title', textKey: 'wnp5_text' },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('wnp_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-4">
            {t('wnp_title1')}<br />{t('wnp_title2')}
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">{t('wnp_desc')}</p>
        </div>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-0.5 bg-gradient-to-r from-slate-100 via-sky-200 to-slate-100 z-0"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative z-10">
            {steps.map((step, index) => (
              <div key={step.numKey} className="text-center flex flex-col items-center">
                <div className={`w-20 h-20 rounded-full border-4 flex flex-col items-center justify-center mb-5 bg-white ${index === 0 ? 'border-sky-500' : index === steps.length - 1 ? 'border-sky-500' : 'border-slate-200'}`}>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${step.icon} text-2xl ${index === 0 || index === steps.length - 1 ? 'text-sky-600' : 'text-slate-600'}`}></i>
                  </div>
                </div>
                <div className="text-sky-500 text-xs font-black uppercase tracking-widest mb-2">{t(step.numKey)}</div>
                <h3 className="text-slate-800 font-bold text-base mb-2">{t(step.titleKey)}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{t(step.textKey)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA bar */}
        <div className="mt-14 bg-sky-600 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-black text-xl mb-1">{t('wnp_cta_title')}</h3>
            <p className="text-white/80 text-sm">{t('wnp_cta_desc')}</p>
          </div>
          <a
            href="#windows-form"
            className="bg-white text-sky-600 font-bold px-8 py-3.5 rounded-lg whitespace-nowrap cursor-pointer hover:bg-sky-50 transition-colors text-sm shrink-0 inline-block"
          >
            {t('wnp_cta_btn')}
          </a>
        </div>
      </div>
    </section>
  );
}
